import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { Tile } from '@mc/design-system'
import { useStaticData } from '@mc/static-data-react'
import { DynamicHeroValues, useCMDynamicHero } from 'libs/dynamic-hero'
import { PrunedCourse } from 'libs/server/api'
import { HeroData } from '../../types'
import {
  MobileBackgroundImage,
  DesktopBackgroundImage,
} from './BackgroundImage'
import { ContentMobile, ContentDesktop } from './Content'

export const Hero = () => {
  const { course, savedDynamicHero } = useStaticData<{
    course: PrunedCourse
    savedDynamicHero: DynamicHeroValues
  }>()

  const { header, subheader, nameplate } = useCMDynamicHero({
    useCourseDefaultValues: true,
  })

  const data: HeroData = {
    header,
    subheader,
    nameplate,
    isDynamicNameplate:
      !isEmpty(savedDynamicHero) &&
      'nameplate' in savedDynamicHero &&
      savedDynamicHero.nameplate !== course.nameplate,
  }

  return (
    <section className='mc-mb-10'>
      {/* Desktop and Tablet */}
      <div className='d-none d-md-flex'>
        <div className='col-6 mc-p-0' style={{ height: 700 }}>
          <Tile aspectRatio='auto'>
            <DesktopBackgroundImage />
          </Tile>
        </div>
        <div
          className='col-6 d-flex align-items-center justify-content-center'
          style={{ background: 'linear-gradient(0deg, #000 0%, #222326 100%)' }}
        >
          <ContentDesktop data={data} />
        </div>
      </div>

      {/* Mobile */}
      <div className='d-block d-md-none'>
        <MobileBackgroundImage />

        <div style={{ marginTop: '-90px' }}>
          <ContentMobile data={data} />
        </div>
      </div>
    </section>
  )
}
